<template>
  <ul class="common-menu">
    <li v-for="(item,index) in menuData" :key="index" class="menu-item">
      <span class="menu-title" @click="secondShowFun(index,item.menuList.length)">
        {{item.title}}
        <i v-if="item.menuList.length>0" class="fold-icon"></i>
      </span>
      <div class="menu-content">
        <ul>
          <li v-for="(item1,index1) in item.menuList" :key="index1">
            <!-- <router-link :to="item1.url ? item1.url : '#'"> -->
              <span class="second-title" @click="gotoRouter(item1,item)">
                <i class="divi"></i>
                {{item1.secondTitle}}
              </span>
            <!-- </router-link> -->
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'MobMenu',
  props: {
    menuData: Array,
    menuEle: String
  },
  data () {
    return {}
  },
  created () {
    console.log(this.menuEle)
  },
  methods: {
    gotoRouter (item, fitem) {
      let reg = RegExp(/http/)
      if (!reg.test(item.url)) {
        this.$router.push({
          path: item.url,
          query: {
            name: item.name,
            index: item.index
          }
        })
        if (fitem.secondTitle === '产业布局') {
          this.$router.push({
            path: item.url,
            query: {
              name: item.name,
              index: item.index,
              title: item.secondTitle
            }
          })
        }
      } else {
        window.open(item.url)
      }
    },
    secondShowFun (index, length) {
      if (length > 0) {
        let iopen = $('.' + this.menuEle + ' .menu-item')
          .eq(index)
          .children()
          .find('i.fold-icon')
        if (iopen.hasClass('open')) {
          iopen.removeClass('open')
        } else {
          iopen.addClass('open')
        }
        let menuContent = $('.' + this.menuEle + ' .menu-item')
          .eq(index)
          .children('.menu-content')
        if (menuContent.hasClass('secondShow')) {
          menuContent.removeClass('secondShow')
        } else {
          menuContent.addClass('secondShow')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
ul.common-menu {
  li.menu-item {
    padding: 0 0.6rem;
    border-bottom: 0.01rem solid rgba(255, 255, 255, 0.15);
    overflow: hidden;
    .menu-content {
      height: 0;
      transition: all 0.1s;
      ul {
        margin-bottom: 0.2rem;
        overflow: hidden;
        padding-left: 0.47rem;
        li {
          width: 50%;
          float: left;
          .second-title {
            font-size: 0.28rem;
            color: #999999;
            line-height: 0.88rem;
            height: 0.88rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            .divi {
              display: inline-block;
              width: 0.04rem;
              height: 0.2rem;
              background: #f67a42;
              margin-right: 0.2rem;
            }
          }
        }
      }
      &.secondShow {
        height: 100%;
      }
    }
    .menu-title {
      display: block;
      font-size: 0.3rem;
      font-weight: 600;
      line-height: 1.2rem;
      height: 1.2rem;
      width: 100%;
      text-align: left;
      position: relative;
      color: #ffffff;
      .fold-icon {
        content: '';
        width: 0.3rem;
        height: 0.3rem;
        background: url('../assets/image/mob/down_arrow.svg') no-repeat;
        background-size: cover;
        position: absolute;
        top: 0.45rem;
        right: 0;
        transition: all 0.1s;
        &.open {
          background: url('../assets/image/mob/up_arrow.svg') no-repeat;
          background-size: cover;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MobMenu.vue